var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 0.166748C110.171 0.166748 141.833 31.8292 141.833 71.0001C141.833 110.171 110.171 141.833 71 141.833C31.8291 141.833 0.166626 110.171 0.166626 71.0001C0.166626 31.8292 31.8291 0.166748 71 0.166748ZM96.4291 35.5834L71 61.0126L45.5708 35.5834L35.5833 45.5709L61.0125 71.0001L35.5833 96.4292L45.5708 106.417L71 80.9876L96.4291 106.417L106.417 96.4292L80.9875 71.0001L106.417 45.5709L96.4291 35.5834Z",
    fill: "#E94D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseErrorIcon);
export default __webpack_public_path__ + "static/media/CloseErrorIcon.4e047a1980e5a908923a9cee3d9e40c5.svg";
export { ForwardRef as ReactComponent };